module.exports = __webpack_public_path__ + "img/ph-back.adbf9434.png";